<template>
  <div class="how-to-swap d-flex flex-column align-items-center">
    <h4 class="title text-center color-plum mb-0">
      How Swapping Works
    </h4>
    <img
      :src="imgUrl"
      alt="How To Swap"
      class="swap-image w-100 my-md">
    <div class="steps-container d-flex flex-column gap-sm w-100">
      <div
        v-for="(step, index) in steps"
        :key="`step-${index}`"
        class="d-flex gap-xs align-items-start">
        <div class="step-number flex-shrink-0 d-flex align-items-center justify-content-center">
          <h4 class="mb-0 color-white">
            {{ index + 1 }}
          </h4>
        </div>
        <div>
          <p class="mb-0 fw-bold">
            {{ step.title }}
          </p>
          <p
            v-if="step.text"
            class="mb-0">
            {{ step.text }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const imgUrl = 'https://d2ezpplblfgpjx.cloudfront.net/onboarding/HowToSwap.png'

const steps = [
  {
    title: 'Go to Case, click Swap',
    text: 'Tell us what you want to return, choose one item or all of them.'
  },
  {
    title: 'Select new items'
  },
  {
    title: 'Keep items until new case arrives',
    text: 'Return items within 24 hrs of delivery.'
  }
]
</script>

<style lang="scss" scoped>
.how-to-swap {
  width: 100%;
  @include media-tablet-or-smaller() {
    margin-top: 30%;
  }

  .title {
    margin-bottom: 0;
  }

  .swap-image {
    aspect-ratio: 325 / 127;
    object-fit: contain;
    max-width: 325px;
  }

  .step-number {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: $orchid;
  }

  .steps-container {
    padding: 0 $spacing-xl;
  }
}

</style>

